export const settingsHubDe = {
  title: 'Einstellungen',
  subtitle: 'Alle Konfigurationsbereiche des Mandanten an einer Stelle.',
  personal: 'Persönlich',
  configuration: 'Konfiguration',
  empty: 'Für Ihre Rolle sind keine Konfigurationsbereiche freigegeben.',
  areas: {
    setup: {
      title: 'Einrichtung & Einrichtungscheck',
      description: 'Geführte Mandanteneinrichtung, Fortschritt, Prüfläufe und Freigabe.',
    },
    profile: {
      title: 'Mein Profil',
      description: 'Name, Sprache und Anzeigeeinstellungen.',
    },
    security: {
      title: 'Sicherheit',
      description: 'Passwort, Zwei-Faktor-Authentifizierung und aktive Sitzungen.',
    },
    company: {
      title: 'Unternehmensprofil',
      description: 'Stammdaten, Bankverbindung, USt-IdNr. und Standardtexte für Belege.',
    },
    users: {
      title: 'Benutzer & Rollen',
      description: 'Team-Accounts, RBAC-Berechtigungsmatrix und Zwei-Faktor-Pflicht.',
    },
    pdfDesigner: {
      title: 'PDF-Designer',
      description: 'Drag-&-Drop-Vorlagen für Angebote, Aufträge und Rechnungen.',
    },
    documentHeaders: {
      title: 'Kundendaten im Belegkopf',
      description: 'Felder, Bereiche und Sichtbarkeit getrennt nach Belegart verwalten.',
    },
    accounting: {
      title: 'DATEV & Intrastat',
      description: 'SKR03/04-Kontenmapping, Berater- und Mandantennummer, Meldeläufe.',
    },
    banking: {
      title: 'Banking & Zahlungsabgleich',
      description: 'AISP, Synchronisation, Matching, Kontierung und sichere Importprofile.',
    },
    whatsapp: {
      title: 'WhatsApp Business API',
      description: 'Meta-Cloud-API-Token, Webhooks und Nachrichtenvorlagen.',
    },
    notifications: {
      title: 'Benachrichtigungen',
      description: 'Regeln für Mindestbestand, MHD-Warnungen und Zahlungseingänge.',
    },
    salesRules: {
      title: 'Vertriebsregeln & Kundenpflege',
      description: 'Empfehlungen simulieren, Schwellenwerte pflegen und automatische Läufe planen.',
    },
    translations: {
      title: 'Sprachen & Übersetzungen',
      description: 'Mandantenspezifische Fachbegriffe und geschützte Bezeichnungen verwalten.',
    },
    customFields: {
      title: 'Custom Fields & GoBD-Vault',
      description: 'Dynamische Zusatzfelder und revisionssichere Änderungsprotokolle.',
    },
    system: {
      title: 'System & Backups',
      description: 'SMTP-Test, Datenbanksicherungen, Import/Export und Telemetrie.',
    },
  },
  links: {
    setup: 'Einrichtung öffnen',
    company: 'Firmendaten bearbeiten',
    users: 'Benutzerverwaltung',
    roles: 'Rollen & Rechte',
    securityLog: 'Sicherheitsprotokoll',
    templates: 'Belegvorlagen',
    documentHeaders: 'Kundendaten im Belegkopf',
    accounting: 'Kontenmapping',
    datev: 'DATEV-Export',
    intrastat: 'Intrastat-Meldung',
    banking: 'Banking konfigurieren',
    whatsapp: 'Verbindung & Vorlagen',
    notifications: 'Alert-Regeln',
    salesRules: 'Vertriebsregeln verwalten',
    translations: 'Übersetzungsglossar',
    customFields: 'Zusatzfelder',
    auditVault: 'GoBD-Vault',
    system: 'Systemzustand',
    errorLogs: 'Fehlerzentrale',
    mailBackups: 'Mailserver & Backups',
    dataHub: 'Import & Export',
  },
} as const;
